export const HOURLY_MINIMUM_HOURS = 5;

export const HOURLY_PRICING_TIERS = [
  {
    key: "luxury-sedan",
    vehicle: "Luxury Sedan",
    capacity: "1–3 passengers",
    hourly: 130,
  },
  {
    key: "chevrolet-suburban-lt",
    vehicle: "Chevrolet Suburban LT SUV",
    capacity: "Up to 6 passengers",
    hourly: 150,
  },
  {
    key: "mercedes-sprinter-6",
    vehicle: "Mercedes-Benz Sprinter Van",
    capacity: "Up to 6 passengers",
    hourly: 175,
  },
  {
    key: "mercedes-sprinter-7-10",
    vehicle: "Mercedes-Benz Sprinter Van",
    capacity: "7–10 passengers",
    hourly: 200,
  },
  {
    key: "mercedes-sprinter-11-14",
    vehicle: "Mercedes-Benz Sprinter Van",
    capacity: "11–14 passengers",
    hourly: 225,
  },
] as const;

export const HOURLY_PRICING_STATEMENT =
  "Luxury Sedan $130/hour, Chevrolet Suburban LT SUV up to 6 passengers $150/hour, Mercedes-Benz Sprinter Van up to 6 passengers $175/hour, Mercedes-Benz Sprinter Van for 7–10 passengers $200/hour, and Mercedes-Benz Sprinter Van for 11–14 passengers $225/hour. Every hourly tier requires a five-hour minimum.";

export const HOURLY_RATE_SUMMARY = HOURLY_PRICING_TIERS.map((tier) => ({
  label: `${tier.vehicle} (${tier.capacity.toLowerCase()})`,
  vehicle: tier.vehicle,
  capacity: tier.capacity,
  rate: `$${tier.hourly} / hr`,
}));